import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useRef } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import TagsAnchorContainer from "../TagsAnchorContainer";
import { useSectionRefs } from "../../../hooks/useSectionRefs";

const HelpTopicGestionParticipants = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { anchorsParts, topic, isLoading, LoadingComponent } = useSectionRefs();
  if (isLoading) return <LoadingComponent />;
  
  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Gestion de votre compétition', link: '/topics/gestion-compet'},
    { label: "Général", link: '/topics/gestion-compet/general'}, 
    { label: topic.title, link: topic.link},
  ]

  // <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/app/dashboard`}>dashboard</a>

  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Depuis votre espace
              <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/app/dashboard`}>admin,</a> 
              cliquez sur l'onglet <strong>Participants.</strong><br/>
              C'est ici que vous trouverez la liste complète de tous les participants inscrits à votre compétition.
            </p>
            <TagsAnchorContainer parts={anchorsParts} legend='Dans cet article'/>
            <div className="article-container mt-40" ref={anchorsParts[0].ref}>
              <p className="help-title-part">{anchorsParts[0].content}</p>
              <p className="help-text">
                Dans la barre latérale secondaire, vous trouverez la liste des catégories. Par défaut, 
                l'option <strong>Tous</strong> est sélectionnée, vous permettant ainsi de voir la liste complète 
                de tous les participants.
              </p>
              <p className="help-text">
                Vous pouvez aussi facilement filtrer vos athlètes par catégorie en cliquant sur le nom de la catégorie souhaitée.
                Depuis cette section, vous pouvez trier les participants par ordre alphabétique ou par classement, si des scores 
                ont déjà été attribués.
              </p>
              <p className="help-text">
                Enfin, une barre de recherche est à votre disposition. Combinée à votre sélection de catégorie, 
                elle vous permet de retrouver précisément un participant.
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[1].ref}>
              <p className="help-title-part">{anchorsParts[1].content}</p>
              <p className="help-text mb-4">
                Vous avez la possibilité de modifier le nom d'une équipe. 
              </p>
              <p className="help-text">
                Pour se faire, cliquer sur le <i className="fa-solid fa-pencil ml-8 mr-8"></i> 
                puis saisissez le nouveau nom. Pour le valider, 
                cliquer sur <i className="fa-solid fa-square-check fz-20 ml-8 color-bleu"></i>
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[2].ref}>
              <p className="help-title-part">{anchorsParts[2].content}</p>
              <p className="help-text">
                Vous pouvez également modifier la catégorie d'une équipe si nécessaire.
                Juste au-dessus de la liste des participants, deux onglets sont disponibles : 
                <strong className="ml-8">Nom</strong> (sélectionné par défaut) et <strong>Changement de catégorie.</strong>
              </p>
              <ul>
                <li className="pl-8 mb-8">
                  <p className="help-text">Cliquez sur l'onglet <strong>Changement catégorie</strong></p>
                </li>
                <li className="pl-8 mb-8">
                  <p className="help-text">Cochez l’équipe ou les équipes dont vous souhaitez modifier la catégorie.</p>
                </li>
                <li className="pl-8 mb-8">
                  <p className="help-text">Cliquez sur le bouton <strong>Modifier la catégorie.</strong></p>
                </li>
                <li className="pl-8 mb-8">
                  <p className="help-text">
                    Dans la modale qui s'est ouverte, choisissez votre nouvelle catégorie, puis cliquez
                    sur <strong>Modifier</strong>
                  </p>
                </li>
              </ul>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[3].ref}>
              <p className="help-title-part">{anchorsParts[3].content}</p>
              <p className="help-text">
                Envoyez facilement un e-mail à tous vos athlètes inscrits, ou ciblez une catégorie spécifique grâce à 
                notre outil de mail intégré.
              </p>
              <p className="help-text">
                Cliquez sur le <strong>bouton Envoyer e-mail</strong> situé à droite des onglets "Nom" et "Changement catégorie".
              </p>
              <ul>
                <li className="pl-8 mb-8">
                  <p className="help-text">
                    Cliquez sur le bouton <strong>A</strong> pour ouvrir une modale. Vous pourrez ensuite sélectionner la 
                    ou les catégories concernées, ou choisir "Tous" pour envoyer l'e-mail à l'ensemble des athlètes inscrits.
                  </p>
                </li>
                <li className="pl-8 mb-8">
                  <p className="help-text">
                    Saisissez un objet clair et précis pour votre e-mail.
                  </p>
                </li>
                <li className="pl-8 mb-8">
                  <p className="help-text">
                    Saisissez le contenu votre e-mail via notre éditeur de texte.
                  </p>
                </li>
                <li className="pl-8 mb-8">
                  <p className="help-text">
                    Cliquez sur le bouton <strong>Envoyer</strong>
                  </p>
                </li>
              </ul>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[4].ref}>
              <p className="help-title-part">{anchorsParts[4].content}</p>
              <p className="help-text">
                Si vous avez choisi le format<a target='_blank' className="link" href={`#`}>Tri au ranking</a>
                pour votre compétition, vous avez accès au bouton <strong>Répartition par ranking.</strong>
              </p>
              <p className="help-text">
                En cliquant dessus, vous pouvez automatiquement et facilement répartir vos athlètes dans leurs nouvelles catégories 
                en fonction de leur classement.
              </p>
              <ul>
                <li className="pl-8 mb-16">
                  <p className="help-text">
                    <strong className="mr-8">Choisissez la catégorie source : </strong>
                    Il s'agit de sélectionner la catégorie dans laquelle vos athlètes se sont initialement inscrits 
                    (par exemple : Hommes RX, Inter, Scaled). Cette catégorie servira de base pour leur répartition.
                  </p>
                </li>
                <li className="pl-8 mb-16">
                  <p className="help-text mb-8">
                    <strong className="mr-8">Choisissez les catégories cibles : </strong>
                    Choisissez les catégories dans lesquelles vos athlètes seront répartis. L'ordre de ces catégories 
                    est crucial. Vous pouvez le modifier facilement en réorganisant les catégories affichées en gris grâce 
                    au drag and drop.
                  </p>
                </li>
                <li className="pl-8 mb-16">
                  <p className="help-text mb-8">
                    Cliquez sur lancer la répartition
                  </p>
                </li>
              </ul>
              <p className="help-text mt-24 mb-16">
                <strong className="mr-8">À noter :</strong> Les athlètes seront répartis en fonction du nombre de places 
                disponibles que vous avez défini pour chaque catégorie cible. Par exemple, si 120 athlètes se sont 
                inscrits dans la catégorie "Hommes RX, Inter, Scaled" et que vous avez fixé 40 places pour chacune 
                des catégories cibles, le système répartira automatiquement les athlètes selon ces limites.
              </p>
              <p className="help-text">
                Ainsi, les 40 meilleurs athlètes inscrits dans "Hommes RX, Inter, Scaled" seront placés en RX, 
                les 40 suivants en Inter, et les 40 derniers en Scaled.
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[5].ref}>
              <p className="help-title-part">{anchorsParts[5].content}</p>
              <p className="help-text">
                Si vous avez choisi le format<a target='_blank' className="link" href={`#`}>Draft</a>
                pour votre compétition, vous avez accès au bouton <strong>Composer une team.</strong>
              </p>
              <p className="help-text">
                En cliquant dessus, vous obtenez la liste des athlètes réparties par genre :
              </p>
              <ul>
                <li className="pl-8 mb-8">
                  <p className="help-text">
                    Cocher ceux qui vont former une équipe et cliquer sur le bouton <strong>Composer la team.</strong>
                  </p>
                </li>
                <li className="pl-8 mb-8">
                  <p className="help-text">
                    Saisissez ensuite le nom de l'équipe.
                  </p>
                </li>
                <li className="pl-8 mb-8">
                  <p className="help-text mb-8">
                    Cliquez sur enregistrer
                  </p>
                </li>
              </ul>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[6].ref}>
              <p className="help-title-part">{anchorsParts[6].content}</p>
              <p className="help-text">
                Lorsque vous créez une nouvelle catégorie, des participants de test sont automatiquement générés. 
                Si le mode<a target='_blank' className="link" href={'#'}>Test</a>est activé dans la navbar, 
                un bandeau orange apparaîtra, et toutes les données des participants basculeront en mode test.
              </p>
              <p className="help-text">
                Cela peut vous permetre de visualiser des participants dans votre tableau de bord, de tester 
                comment faire toutes les manipulations vu plus haut dans cet article.
              </p>
              <p className="help-text">
                <strong className="mr-8">NB : </strong>
                Ces données de test sont principalement utiles pour vérifier les WODs et le leaderboard. 
                Mais qui sait ? Elles pourraient également vous servir dans d'autres situations.
              </p>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicGestionParticipants